import { SessionHelper } from './../helper/sessionHelper';
import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/acceso/auth.service';
import { Configuration } from './../configuration/configuration';
import { NgxPermissionsService } from 'ngx-permissions';
import { Errors } from '../configuration/errors';
import { PathRoutes } from '../configuration/pathRoutes';

// *************************************************//
// Guard que controla el acceso a secciones de
// la web sólo accesible por usuarios autenticados.
// *************************************************//
@Injectable()
export class AuthorizatedGuard implements CanActivate {
  constructor(
    private router: Router,
    private _authService: AuthService,
    private _ngxPermissionsService: NgxPermissionsService,
    private _session: SessionHelper
  ) {}

  // Implementación del CanActivate.
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this._authService.isLoggedIn()) {
      this._ngxPermissionsService.loadPermissions(
        this._session.User.Roles
      );
      return true;
    }

    // No logeado por lo que redirigimos a la pantalla de login.
    this.router.navigate([PathRoutes.error], {state: Errors.sessionExpired});
    return false;
  }
}

